'use client';

import { useForYouList } from '@/features/for-you/hooks/useForYouList';
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import { tagService } from '../services/tagService';
import type { IPagination } from '../types/common';

export const usePopularTags = (params: IPagination) => {
	return useQuery({
		queryKey: ['tags', 'popular', params],
		queryFn: () => tagService.getPopularTags(params),
	});
};

export const useTagDetail = (tag: string) => {
	return useQuery({
		queryKey: ['tag-detail', tag],
		queryFn: () => tagService.getTagInfo(tag),
	});
};

export const useFollowTag = () => {
	return useMutation({
		mutationFn: (tag: string) => tagService.followTag(tag),
	});
};

export const useUnfollowTag = () => {
	return useMutation({
		mutationFn: (tag: string) => tagService.unfollowTag(tag),
	});
};

export const useTagFollower = (tag: string, params: IPagination) => {
	return useQuery({
		queryKey: ['tag-follower', tag],
		queryFn: () => tagService.getTagFollowers(tag, params),
	});
};

export const useTagPosts = (tag: string) =>
	useForYouList(({ page, size }: IPagination) => {
		return useInfiniteQuery({
			queryKey: ['tag-posts', tag, page, size],
			queryFn: () => tagService.getTagConversations(tag, { page, size }),
			getNextPageParam: (lastPage) =>
				lastPage.page.last ? undefined : lastPage.page.number + 1,
			initialPageParam: 1,
			enabled: !!size,
		});
	});
